import UmDraw from './src/main'

/* istanbul ignore next */
UmDraw.install = function(Vue) {
  Vue.component(UmDraw.name, UmDraw)
}

export default UmDraw
